export const environment = {
  production: false,
  assetUrl: 'https://assets-stage.syngentaebiz.com/pdf/media/',
  s3:{
    DistributionID:"E205ME6JC5FEIU,EGBYC836VVHS1",
    BucketName: "usae-btwoc-assets-stage",
    FolderPath: "assets/stage/",
    FilePath: "null"
  },
  api: {
    cmsUrl: 'https://cms-api-stg-support.alfprod.com',
    credentials: {
      Username: "cms@admin",
      Password: "$yngent@2022",
      WebsiteName: "string"
    }
  }
};

export const oktaApp = {
  oidc: {
    clientId: '0oa1xjgr6o60u4TFs0h8',
    issuer: 'https://signin-test.syngenta.com/oauth2/ausqmgapztkTfvQg70h7',
    redirectUri: 'https://stagesupport.premixcalculator.syngentadigitalapps.com/login/callback',
    postLogoutRedirectUri: 'https://stagesupport.premixcalculator.syngentadigitalapps.com',
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    testing: {
      disableHttpsCheck: false
    }
  }
};

export const admins = {
  emailAddress: ['mahipalsingh.choudhary@syngenta.com', 'swarup.saha@syngenta.com','kham.soundara@syngenta.com', 'dj.mahoney@syngenta.com','venkatesan.mohalingam@syngenta.com']
}
